import React from "react";
import Loader from "../../components/loaders/Loader";
import Dialog from "../../components/dialog/Dialog";
import DialogContent from "../../components/dialog/DialogContent";
import DialogFooter from "../../components/dialog/DialogFooter";
import Recommendation from "../../types/admin/Recommendation";
import DialogCancel from "../../components/dialog/DialogCancel";
import Panel from "../../components/panels/Panel";
import { Side } from "../../types/system/Layout";
import { connect } from "react-redux";
import { IAppState } from "../../state/Store";
import { initialiseRecommendations } from "../../state/administration/Recommendations";

import "./Recommendations.scss";

interface RecommendationListProps {
    status?: boolean;
    recommendations?: Recommendation[];
    initialiseRecommendations?: Function;
}

interface RecommendationListState {
    recommendation: Recommendation;
    showRecommendation: boolean;
}

class RecommendationList extends React.Component<
    RecommendationListProps,
    RecommendationListState
> {
    state = {
        recommendation: null,
        showRecommendation: false,
    };

    componentDidMount() {
        this.props.initialiseRecommendations();
    }

    setRecommendation(value: Recommendation) {
        this.setState(() => ({ recommendation: value }));
    }

    setShowRecommendation(value: boolean) {
        this.setState(() => ({ showRecommendation: value }));
    }

    showRecommdation(recommendation: Recommendation) {
        this.setRecommendation(recommendation);
        this.setShowRecommendation(true);
    }

    render() {
        return (
            <div className="recommendations-list items">
                {this.props.status ? (
                    this.props.recommendations
                        .filter(recommendation => recommendation.isRecommended)
                        .filter((_, index) => index < 3)
                        .map((recommendation, index) => {
                            return (
                                <div
                                    className="item"
                                    key={index}
                                    tabIndex={0}
                                    onClick={() =>
                                        this.showRecommdation(recommendation)
                                    }>
                                    <span className="header">
                                        <i
                                            className={`icon type${recommendation.severity}`}></i>
                                        <span className="title">
                                            {recommendation.title}
                                        </span>
                                    </span>
                                    <span className="summary">
                                        {recommendation.summary}
                                    </span>
                                </div>
                            );
                        })
                ) : (
                    <Loader></Loader>
                )}
                {this.props.status && (
                    <Dialog
                        width={620}
                        zIndex={99}
                        dialogIcon={this.state.recommendation?.icon}
                        dialogIconStyle={this.state.recommendation?.iconColor}
                        dialogTitle={this.state.recommendation?.title ?? ""}
                        showDialog={this.state.showRecommendation}>
                        <DialogContent>
                            <Panel bufferSide={Side.All}>
                                <h3 style={{ whiteSpace: "normal" }}>
                                    {this.state.recommendation?.summary ?? ""}
                                </h3>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            this.state.recommendation
                                                ?.description ?? "",
                                    }}></p>
                            </Panel>
                        </DialogContent>
                        <DialogFooter>
                            <DialogCancel
                                text="Close Recommendation"
                                onClick={() =>
                                    this.setShowRecommendation(false)
                                }></DialogCancel>
                        </DialogFooter>
                    </Dialog>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { recommendations } = state.db;

    return {
        status: recommendations.status === "succeeded",
        recommendations: recommendations.recommendations,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseRecommendations: () => dispatch(initialiseRecommendations()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationList);
